import React, { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

import type Api from '@api-service/api'

const ApiServiceContext = createContext<
  | {
      service?: Api
      apiBases?: Readonly<Record<string, string>>
    }
  | undefined
>(undefined)

export const ApiServiceProvider = (props: {
  children: ReactNode
  service?: Api
  apiBases?: Readonly<Record<string, string>>
}) => {
  return (
    <ApiServiceContext.Provider value={{ service: props.service, apiBases: props.apiBases }}>
      {props.children}
    </ApiServiceContext.Provider>
  )
}

export const useApiService = () => {
  const value = useContext(ApiServiceContext)
  if (!value) {
    throw new Error('useFlowsServices must be used within FlowsServicesProvider')
  }
  return value
}
